import VueTypes, { nullable } from 'vue-types';

export const PopularQuestionItem = VueTypes.shape({
    id: VueTypes.oneOfType([Number]).isRequired,
    question: VueTypes.oneOfType([String]).isRequired,
    answer: VueTypes.oneOfType([String, nullable]).isRequired,
}).isRequired

export const PopularQuestions = VueTypes.shape({
    id: VueTypes.oneOfType([Number]).isRequired,
    name: VueTypes.oneOfType([String]).isRequired,
    questions: VueTypes.arrayOf(PopularQuestionItem).isRequired.def([]),
}).isRequired;


export const createPopularQuestionsItem = ({ id, answer, question }) => {
    return {
        id: id,
        question: question,
        answer: answer
    };
}

export const createPopularQuestions = ({ name, id, questions = [] }) => {
    return {
        id: id,
        name: name,
        questions: questions
    }
}